import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import { CircularProgress } from 'material-ui';
// import api from '../../../lib/api';
import { withRouter } from 'react-router-dom';

import {
  Title,
  GetCompanyIdContainer,
  FormSection,
  InputSection,
  DetailsOfInput,
  InputTilte,
  InputFieldWithSubmit,
  Input,
  GetCompanyIdButton
} from './styles';

class GetCompanyPitch extends Component {
  static propTypes = {
    history: PropTypes.object
  };
  state = {
    companyId: ''
  };

  updateValue = event => {
    event.preventDefault();
    this.setState({ companyId: event.target.value });
  };

  redirectToCompanyPitchDetails = () => {
    const { companyId } = this.state;
    if (!companyId.trim()) {
      return alert('Please enter valid value');
    }
    this.props.history.push(`/salesJetpack?companyId=${companyId}`);
  };

  handleKeyDown = event => {
    if (event.key === 'Enter') {
      this.redirectToCompanyPitchDetails(event.target.name);
    }
  };

  render() {
    const { companyId } = this.state;
    return (
      <GetCompanyIdContainer>
        <FormSection>
          <Title>Get company pitch</Title>
          <InputSection>
            <DetailsOfInput>
              <InputTilte>Company ID</InputTilte>
            </DetailsOfInput>
            <InputFieldWithSubmit>
              <Input
                value={companyId}
                name="companyId"
                onChange={this.updateValue}
                onKeyDown={this.handleKeyDown}
              />
              <GetCompanyIdButton
                loading={false}
                disabled={false}
                onClick={() => this.redirectToCompanyPitchDetails()}
              >
                Get Sales Pitch
              </GetCompanyIdButton>
            </InputFieldWithSubmit>
          </InputSection>
        </FormSection>
      </GetCompanyIdContainer>
    );
  }
}

export default withRouter(GetCompanyPitch);



// WEBPACK FOOTER //
// ./src/pages/SalesUtility/GetCompanyPitch/index.js